/**
 * The admin's calendars speak Russian (registration-approval design FD-8):
 * month and weekday names come from the dayjs Russian locale, loaded here
 * once, and weeks start on Monday (Mantine's default). `main.tsx` hands these
 * settings to the one `DatesProvider` at the root; no picker sets a locale of
 * its own.
 *
 * A date typed by hand is read by its field's `valueFormat`: Mantine parses the
 * text with `dayjs(text, valueFormat)`, which ignores the format unless dayjs
 * has its custom-parse plugin — the browser then reads «04.10.2026» month
 * first, as 10 April, and refuses «25.10.2026» (BUG-356).
 */
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/ru';
import type { DatesProviderProps } from '@mantine/dates';

dayjs.extend(customParseFormat);

export const ADMIN_DATES_SETTINGS: DatesProviderProps['settings'] = { locale: 'ru' };
